import Sync from 'assets/icons/md/md-sync.svg'

Sync.displayName = 'Sync'
export default Sync
